module.exports = __webpack_public_path__ + "img/overallSummary.6253e85b.svg";